import { render, staticRenderFns } from "./ShipmentDataTable.vue?vue&type=template&id=c1e48498&scoped=true"
import script from "./ShipmentDataTable.vue?vue&type=script&lang=js"
export * from "./ShipmentDataTable.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDataTable.vue?vue&type=style&index=0&id=c1e48498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e48498",
  null
  
)

export default component.exports